import type { ReactNode } from 'react'
import { cn } from '../lib/cn'

/** A pill toggle for filters and views. The active one goes ink. */
export function FilterChip({
  active,
  onClick,
  className,
  children,
}: {
  active: boolean
  onClick: () => void
  className?: string
  children: ReactNode
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border px-4 py-2 text-[13px] font-semibold transition-colors',
        active
          ? 'border-ink bg-ink text-sage-50'
          : 'border-DEFAULT bg-transparent text-gray-700 hover:bg-gray-900/[0.07]',
        className,
      )}
    >
      {children}
    </button>
  )
}
